import React from "react"
import { motion } from "framer-motion"
import * as styles from "./button.module.scss"

export default function Button(props: any) {
  return (
    <motion.button
      className={styles.button}
      {...{
        whileTap: { scale: 0.9 },
        whileHover: { scale: 1.1 },
        ...props,
      }}
    >
      {props.children}
    </motion.button>
  )
}
